import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store';
import { useApplicationsApi } from '../api';
import { resetError, setError, setLoading } from '../slices';
import {
  CreateAdminApplicationRequestData,
  UpdateAdminApplicationRequestData,
} from '../types';

export const useApplicationService = () => {
  const dispatch = useDispatch();
  const { loading, error } = useAppSelector((state) => state.applications);

  const api = useApplicationsApi();

  const createApplication = useCallback(async (data: CreateAdminApplicationRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ create: true }));

      await api.createAdminApplication(data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ create: false }));
    }
  }, []);

  const updateApplication = useCallback(async (applicationId: string, data: UpdateAdminApplicationRequestData) => {
    try {
      dispatch(resetError());
      dispatch(setLoading({ update: true }));

      await api.updateAdminApplication(applicationId, data);
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ update: false }));
    }
  }, []);

  return {
    loading,
    error,
    createApplication,
    updateApplication,
  };
};
